const state = {
  botmsg: {}
};

export default state;



// WEBPACK FOOTER //
// ./src/store/modules/teachbot/state.js